<script setup>
    import { reactive, ref, onMounted } from "vue";
    import { Modal } from "bootstrap";
    import { router } from '@/router';

    import { useAuthStore } from '@/stores/auth.store.js';
    const authStore = useAuthStore();

    const aws = authStore.aws;


    const MfaDisabledWarningModalRef = ref(null);
    let MfaDisabledWarningModal;

    onMounted(() => {
        if (MfaDisabledWarningModalRef.value) {
            MfaDisabledWarningModal = new Modal(MfaDisabledWarningModalRef.value);
            if (aws && !aws.mfa_enabled) { MfaDisabledWarningModal.show(); }
        }
    });

    const goToAccountSettings = () => {
        router.push('/account');
        MfaDisabledWarningModal.hide();
    }
</script>

<template>
    <div v-if="aws && !aws.mfa_enabled" class="modal fade" ref="MfaDisabledWarningModalRef" id="MfaDisabledWarningModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="MfaDisabledWarningModalLabel" aria-hidden="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="MfaDisabledWarningModallLabel">Update your account</h5>
          </div>
          <div class="modal-body">
            <div class="text-center">Please enable <strong>Two-Factor Authentication</strong> before <br/> you can use the app.</div>
            <div class="mt-3 px-3 warning-hint">To set it up, <br/> you will need the Google Authenticator app installed on your smartphone.</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-purple" @click="goToAccountSettings()">Set up 2FA</button>
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped>
    .warning-hint {
        font-size: 12px;
        color: gray;
    }
</style>